// ci: trigger per-arch build test
import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import App from './App';

import './index.css';
import { sinatraOrigin } from './config';
import { createClient } from '@hey-api/client-fetch';

createClient({
  baseUrl: sinatraOrigin ?? '',
});

const rootNode = document.getElementById('root');

if (rootNode) {
  const root = createRoot(rootNode);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
} else {
  // eslint-disable-next-line no-console -- This is a critical failure and we cannot display errors to the user (unless we use aler())
  console.error('Base HTML has changed and the React App failed to mount to #root.');
}
